var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
import { createAction } from "redux-act";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./auth.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["AuthSetBypassToken"] = "AUTH_SET_BYPASS_TOKEN";
    EActionCustom["AuthSignIn"] = "AUTH_SIGN_IN";
    EActionCustom["AuthSignInAutomatically"] = "AUTH_SIGN_IN_AUTOMATICALLY";
    EActionCustom["AuthSsoSignIn"] = "AUTH_SSO_SIGN_IN";
    EActionCustom["AuthSetSelectedDashboard"] = "AUTH_SET_SELECTED_DASHBOARD";
    EActionCustom["SetAccessTokensWithoutSideEffects"] = "SET_ACCESS_TOKENS_WITHOUT_SIDE_EFFECTS";
    EActionCustom["AuthRefreshSuccess"] = "AUTH_REFRESH_SUCCESS";
    EActionCustom["AuthSignOut"] = "AUTH_SIGN_OUT";
    EActionCustom["AuthSignUp"] = "AUTH_SIGN_UP";
    EActionCustom["AuthSignUpVerifyPhone"] = "AUTH_SIGN_UP_VERIFY_PHONE";
    EActionCustom["AuthSignUpVerifyEmail"] = "AUTH_SIGN_UP_VERIFY_EMAIL";
    EActionCustom["AuthSignUpRequestTokenFromEmail"] = "AUTH_SIGN_UP_REQUEST_TOKEN_FROM_EMAIL";
    EActionCustom["AuthSignUpResendVerificationEmail"] = "AUTH_SIGN_UP_RESEND_VERIFICATION_EMAIL";
    EActionCustom["AuthSignUpResendVerificationSms"] = "AUTH_SIGN_UP_RESEND_VERIFICATION_SMS";
    EActionCustom["AuthUerUpdate"] = "AUTH_USER_UPDATE";
    EActionCustom["AuthUserUpdateById"] = "AUTH_USER_UPDATE_BY_ID";
    EActionCustom["AuthAdminVerifyEmail"] = "AUTH_ADMIN_VERIFY_EMAIL";
    EActionCustom["AuthAdminVerifyPhone"] = "AUTH_ADMIN_VERIFY_PHONE";
    EActionCustom["AuthUserRemoveProfile"] = "AUTH_USER_REMOVE_PROFILE";
    EActionCustom["GetUser"] = "AUTH_USER_GET";
})(EActionCustom || (EActionCustom = {}));
export var setBypassToken = createAction("SET_BYPASS_TOKEN");
var generateSignInActions = function () { return ({
    signInStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Start,
    }),
    signInSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Success,
    }),
    signInFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignIn,
        state: EActionState.Fail,
    }),
}); };
var generateSignInAutomaticallyActions = function () { return ({
    signInAutomaticallyStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Start,
    }),
    signInAutomaticallySucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Success,
    }),
    signInAutomaticallyFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignInAutomatically,
        state: EActionState.Fail,
    }),
}); };
var generateSsoSignInActions = function () { return ({
    ssoSignInStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSsoSignIn,
        state: EActionState.Start,
    }),
    ssoSignInSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSsoSignIn,
        state: EActionState.Success,
    }),
    ssoSignInFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSsoSignIn,
        state: EActionState.Fail,
    }),
}); };
var generateSetSelectedDashboardActions = function () { return ({
    setSelectedDashboardStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Start,
    }),
    setSelectedDashboardSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Success,
    }),
    setSelectedDashboardFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSetSelectedDashboard,
        state: EActionState.Fail,
    }),
}); };
var generateSetAccessTokensWithoutSideEffectsActions = function () { return ({
    setAccessTokensWithoutSideEffectsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Start,
    }),
    setAccessTokensWithoutSideEffectsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Success,
    }),
    setAccessTokensWithoutSideEffectsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.SetAccessTokensWithoutSideEffects,
        state: EActionState.Fail,
    }),
}); };
var generateRefreshSuccessActions = function () { return ({
    refreshSuccessStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Start,
    }),
    refreshSuccessSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Success,
    }),
    refreshSuccessFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthRefreshSuccess,
        state: EActionState.Fail,
    }),
}); };
var generateSignOutActions = function () { return ({
    signOutStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Start,
    }),
    signOutSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Success,
    }),
    signOutFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignOut,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpVerifyPhoneActions = function () { return ({
    signUpVerifyPhoneStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Start,
    }),
    signUpVerifyPhoneSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Success,
    }),
    signUpVerifyPhoneFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyPhone,
        state: EActionState.Fail,
    }),
}); };
var generateGetUserActions = function () { return ({
    getUserStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Start,
    }),
    getUserSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Success,
    }),
    getUserFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetUser,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpActions = function () { return ({
    signUpStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Start,
    }),
    signUpSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Success,
    }),
    signUpFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUp,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpVerifyEmailActions = function () { return ({
    signUpVerifyEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Start,
    }),
    signUpVerifyEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Success,
    }),
    signUpVerifyEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpVerifyEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpRequestTokenFromEmailActions = function () { return ({
    signUpRequestTokenFromEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Start,
    }),
    signUpRequestTokenFromEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Success,
    }),
    signUpRequestTokenFromEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpRequestTokenFromEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpResendVerificationEmailActions = function () { return ({
    signUpResendVerificationEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Start,
    }),
    signUpResendVerificationEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Success,
    }),
    signUpResendVerificationEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationEmail,
        state: EActionState.Fail,
    }),
}); };
var generateSignUpResendVerificationSmsActions = function () { return ({
    signUpResendVerificationSmsStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Start,
    }),
    signUpResendVerificationSmsSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Success,
    }),
    signUpResendVerificationSmsFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthSignUpResendVerificationSms,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateUserActions = function () { return ({
    updateUserStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Start,
    }),
    updateUserSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Success,
    }),
    updateUserFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUerUpdate,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateUserByIdActions = function () { return ({
    updateUserByIdStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Start,
    }),
    updateUserByIdSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Success,
    }),
    updateUserByIdFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserUpdateById,
        state: EActionState.Fail,
    }),
}); };
var generateAdminVerifyEmailActions = function () { return ({
    adminVerifyEmailStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Start,
    }),
    adminVerifyEmailSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Success,
    }),
    adminVerifyEmailFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyEmail,
        state: EActionState.Fail,
    }),
}); };
var generateAdminVerifyPhoneActions = function () { return ({
    adminVerifyPhoneStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Start,
    }),
    adminVerifyPhoneSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Success,
    }),
    adminVerifyPhoneFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthAdminVerifyPhone,
        state: EActionState.Fail,
    }),
}); };
var generateRemoveProfileActions = function () { return ({
    removeProfileStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Start,
    }),
    removeProfileSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Success,
    }),
    removeProfileFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AuthUserRemoveProfile,
        state: EActionState.Fail,
    }),
}); };
export var signInStart = (_a = generateSignInActions(), _a.signInStart), signInSucceeded = _a.signInSucceeded, signInFailed = _a.signInFailed;
export var signOutStart = (_b = generateSignOutActions(), _b.signOutStart), signOutSucceeded = _b.signOutSucceeded, signOutFailed = _b.signOutFailed;
export var signInAutomaticallyStart = (_c = generateSignInAutomaticallyActions(), _c.signInAutomaticallyStart), signInAutomaticallySucceeded = _c.signInAutomaticallySucceeded, signInAutomaticallyFailed = _c.signInAutomaticallyFailed;
export var ssoSignInStart = (_d = generateSsoSignInActions(), _d.ssoSignInStart), ssoSignInSucceeded = _d.ssoSignInSucceeded, ssoSignInFailed = _d.ssoSignInFailed;
export var setSelectedDashboardStart = (_e = generateSetSelectedDashboardActions(), _e.setSelectedDashboardStart), setSelectedDashboardSucceeded = _e.setSelectedDashboardSucceeded, setSelectedDashboardFailed = _e.setSelectedDashboardFailed;
export var setAccessTokensWithoutSideEffectsStart = (_f = generateSetAccessTokensWithoutSideEffectsActions(), _f.setAccessTokensWithoutSideEffectsStart), setAccessTokensWithoutSideEffectsSucceeded = _f.setAccessTokensWithoutSideEffectsSucceeded, setAccessTokensWithoutSideEffectsFailed = _f.setAccessTokensWithoutSideEffectsFailed;
export var refreshSuccessStart = (_g = generateRefreshSuccessActions(), _g.refreshSuccessStart), refreshSuccessSucceeded = _g.refreshSuccessSucceeded, refreshSuccessFailed = _g.refreshSuccessFailed;
export var signUpVerifyPhoneStart = (_h = generateSignUpVerifyPhoneActions(), _h.signUpVerifyPhoneStart), signUpVerifyPhoneSucceeded = _h.signUpVerifyPhoneSucceeded, signUpVerifyPhoneFailed = _h.signUpVerifyPhoneFailed;
export var getUserStart = (_j = generateGetUserActions(), _j.getUserStart), getUserSucceeded = _j.getUserSucceeded, getUserFailed = _j.getUserFailed;
export var signUpStart = (_k = generateSignUpActions(), _k.signUpStart), signUpSucceeded = _k.signUpSucceeded, signUpFailed = _k.signUpFailed;
export var signUpVerifyEmailStart = (_l = generateSignUpVerifyEmailActions(), _l.signUpVerifyEmailStart), signUpVerifyEmailSucceeded = _l.signUpVerifyEmailSucceeded, signUpVerifyEmailFailed = _l.signUpVerifyEmailFailed;
export var signUpRequestTokenFromEmailStart = (_m = generateSignUpRequestTokenFromEmailActions(), _m.signUpRequestTokenFromEmailStart), signUpRequestTokenFromEmailSucceeded = _m.signUpRequestTokenFromEmailSucceeded, signUpRequestTokenFromEmailFailed = _m.signUpRequestTokenFromEmailFailed;
export var signUpResendVerificationEmailStart = (_o = generateSignUpResendVerificationEmailActions(), _o.signUpResendVerificationEmailStart), signUpResendVerificationEmailSucceeded = _o.signUpResendVerificationEmailSucceeded, signUpResendVerificationEmailFailed = _o.signUpResendVerificationEmailFailed;
export var signUpResendVerificationSmsStart = (_p = generateSignUpResendVerificationSmsActions(), _p.signUpResendVerificationSmsStart), signUpResendVerificationSmsSucceeded = _p.signUpResendVerificationSmsSucceeded, signUpResendVerificationSmsFailed = _p.signUpResendVerificationSmsFailed;
export var updateUserStart = (_q = generateUpdateUserActions(), _q.updateUserStart), updateUserSucceeded = _q.updateUserSucceeded, updateUserFailed = _q.updateUserFailed;
export var updateUserByIdStart = (_r = generateUpdateUserByIdActions(), _r.updateUserByIdStart), updateUserByIdSucceeded = _r.updateUserByIdSucceeded, updateUserByIdFailed = _r.updateUserByIdFailed;
export var adminVerifyEmailStart = (_s = generateAdminVerifyEmailActions(), _s.adminVerifyEmailStart), adminVerifyEmailSucceeded = _s.adminVerifyEmailSucceeded, adminVerifyEmailFailed = _s.adminVerifyEmailFailed;
export var adminVerifyPhoneStart = (_t = generateAdminVerifyPhoneActions(), _t.adminVerifyPhoneStart), adminVerifyPhoneSucceeded = _t.adminVerifyPhoneSucceeded, adminVerifyPhoneFailed = _t.adminVerifyPhoneFailed;
export var removeProfileStart = (_u = generateRemoveProfileActions(), _u.removeProfileStart), removeProfileSucceeded = _u.removeProfileSucceeded, removeProfileFailed = _u.removeProfileFailed;
